"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPCUpdate = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var commonweb_utils_1 = require("commonweb-utils");
var icons_component_1 = require("../../../components/icons.component");
/**
 * PP credit address update suggestion page
 */
function PPCUpdate(_a) {
    var content = _a.content, account = _a.account, fpti = _a.fpti, links = _a.links, transitionOutHandler = _a.transitionOutHandler;
    var addressContent = content.addresses;
    var addressFpti = fpti.address;
    var ppcSyncronyProfleDeeplink = commonweb_utils_1.objectUtils.safeGet(account, "addressData.ppcSynchronyDeeplinks.profile") || {};
    return (React.createElement("div", { className: "generic-container" },
        React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "updateWarning-icon", image: "Warning" }),
        React.createElement("div", { className: "updateWarning-content" },
            " ",
            React.createElement(pp_react_1.Text, { size: "xl3" }, addressContent.addUpdate.ppCreditAlert)),
        React.createElement("div", { className: "updateWarning-content" },
            " ",
            React.createElement(pp_react_1.Text, { size: "md" }, addressContent.addUpdate.ppCreditInfo)),
        React.createElement(pp_react_1.Button, { className: "addUpdateButton_space fullWidth", name: addressFpti.goToPPCredit, type: "submit", as: "a", href: ppcSyncronyProfleDeeplink, onClick: transitionOutHandler }, addressContent.addUpdate.ppCreditContinue),
        React.createElement(pp_react_1.Link, { "data-name": addressFpti.notNowPPCredit, href: links.address.manage }, addressContent.addUpdate.ppCreditNotNow)));
}
exports.PPCUpdate = PPCUpdate;
var mapStateToProps = function (_a) {
    var content = _a.content, account = _a.account, fpti = _a.fpti, links = _a.links;
    return ({
        content: content,
        account: account,
        fpti: fpti,
        links: links,
    });
};
exports.default = react_redux_1.connect(mapStateToProps)(PPCUpdate);
